<template>
  <div>
    <el-form ref="accountForm" :model="accountForm" :rules="accountFormRules" label-width="120px">
      <el-form-item label="城市" prop="city">
        <el-select
          v-model="accountForm.city"
          placeholder="请输入城市"
          filterable
          clearable="">
          <el-option
            v-for="item in cityList" :key="item.adcode"
            :value="item.adcode"
            :label="item.city">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="查询网址" prop="domain">
        <div class="">
          <el-input v-model="accountForm.domain" placeholder="请输入网址" @blur="domainBlur"/>
          <p class="tip">请填写交通网站的域名，譬如：https://sc.122.gov.cn</p>
        </div>
      </el-form-item>
      <el-form-item label="登录方式" prop="loginMethod">
        <el-select v-model="accountForm.loginMethod" placeholder="请选择" @change="loginMethodChange">
          <el-option v-for="(value, key) of loginMethodOptions" :key="key" :label="value" :value="Number(key)">
          </el-option>
        </el-select>
      </el-form-item>
      <template v-if="isShowAccountInfo">
        <el-form-item label="账号ID" prop="account">
          <el-input v-model="accountForm.account" placeholder="请输入账号ID"/>
        </el-form-item>
        <el-form-item label="账号密码" prop="password">
          <el-input v-model="accountForm.password" placeholder="请输入账号密码"/>
        </el-form-item>
        <el-form-item label="是否需要U盾" prop="needUdun">
          <div class="">
            <el-radio-group v-model="accountForm.needUdun">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <p class="tip" v-if="accountForm.needUdun === 1">U盾账号，只支持手动查询，查询时请注意根据指引操作</p>
            <p class="tip" v-if="accountForm.needUdun === 0">非U盾账号，支持每日自动查询和数据更新</p>
          </div>
        </el-form-item>
      </template>
    </el-form>
  </div>
</template>
<script>
import { getCityList } from '@/api/domain/cars'
import { addViolationAccount, editViolationAccount } from '@/api/domain/carsService'
import { isURL, isEmojiCharacter, validateURL } from '@/utils/validate'
import { LOGIN_METHOD, LOGIN_METHOD_2_TEXT } from '../../config/account'

export default {
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
    isSave: {
      type: Boolean,
      default: false,
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      accountForm: {
        account: '',
        password: '',
        domain: '',
        city: '',
        needUdun: null,
        loginMethod: '',
      },
      accountFormRules: {
        account: [{ required: true, message: '请输入账号ID', trigger: 'blur' }, { validator: this.validateAccount, trigger: 'blur' }],
        password: [{ required: true, message: '请输入账号密码', trigger: 'blur' }, { validator: this.validatePassword, trigger: 'blur' }],
        domain: [{ required: true, message: '请输入网址', trigger: 'blur' }, { validator: isURL, trigger: 'blur' }],
        city: [{ required: true, message: '请输入城市', trigger: 'change' }],
        needUdun: [{ required: true, message: '请选择是否需要U盾', trigger: 'change' }],
        loginMethod: [{ required: true, message: '请选择登录方式', trigger: 'change' }],
      },
      cityList: [],
      loginMethodOptions: LOGIN_METHOD_2_TEXT,
    }
  },
  computed: {
    isShowAccountInfo() {
      return this.accountForm.loginMethod === LOGIN_METHOD.USER_NAME_PASSWORD
    },
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (!val) return
        if (!this.content) {
          this.accountForm = {
            account: '',
            password: '',
            domain: '',
            city: '',
            needUdun: null,
            loginMethod: '',
          }
          this.$nextTick(() => {
            this.$refs.accountForm.clearValidate()
          })
        } else {
          this.accountForm = { ...this.content }
          this.accountForm.city = this.content.cityCode || ''
          this.$nextTick(() => {
            this.$refs.accountForm.clearValidate()
          })
        }
      },
      immediate: true,
    },
    isSave: {
      handler(val) {
        if (val) {
          this.saveAccount()
        }
      },
    },
  },
  mounted() {
    this.getCityList()
  },
  methods: {
    // 账号只能输入数字
    validateAccount(rule, value, callback) {
      if (!/^\d+$/.test(value.trim())) {
        callback(new Error('只能输入数字'))
      }
      if (value.trim().length > 20) {
        callback(new Error('最长20个字符'))
      }
      callback()
    },
    // 密码不能输入表情
    validatePassword(rule, value, callback) {
      if (isEmojiCharacter(value)) {
        callback(new Error('不能输入表情'))
      }
      if (value.length > 50) {
        callback(new Error('最长50个字符'))
      }
      callback()
    },
    getCityList() {
      getCityList().then(({ code, data }) => {
        if (code === 1) {
          this.cityList = data || []
        }
      })
    },
    saveAccount() {
      this.$refs.accountForm.validate((valid) => {
        if (!valid) {
          this.$emit('saveResult', true)
          return
        }
        let func = addViolationAccount
        if (this.accountForm.id) {
          func = editViolationAccount
        }
        const { account, password, domain, city, needUdun, loginMethod } = this.accountForm
        const params = {
          account: account.trim(),
          password,
          domain: domain.trim(),
          city,
          needUdun: this.isShowAccountInfo ? needUdun : null,
          open: 0,
          loginMethod,
        }
        if (this.accountForm.id) {
          params.id = this.accountForm.id
          params.open = this.isShowAccountInfo ? this.accountForm.open : 0
        }
        (func)(params).then(({ code }) => {
          if (code === 1) {
            this.$emit('saveResult', false)
          } else {
            this.$emit('saveResult', true)
          }
        }).catch(() => {
          this.$emit('saveResult', true)
        })
      })
    },
    domainBlur() {
      const { domain } = this.accountForm
      if (validateURL(domain)) {
        const URLObj = new URL(domain)
        this.accountForm.domain = URLObj.origin
      }
    },
    loginMethodChange() {
      this.accountForm.account = ''
      this.accountForm.password = ''
      this.accountForm.needUdun = null
    },
  },
}
</script>
<style lang="less" scoped>
.tip {
  color: #807d7d;
  font-size: 12px;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
